import React, {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import {Tooltip} from 'react-tooltip'
import {ModeleVehiculeEntre} from '../../../components/Models'
import {useAuth} from '../../modules/auth'
import {getMarqueVehicule, getModeleVehicule, getVehicules} from '../../../components/requests'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {Pagination} from '../../../components/Pagination'
import {VehiculeToShowPage} from './VehiculeShowPage'
import {useSearchParams} from 'react-router-dom'
import Select from 'react-select'
import CustomOption from "../demande/Components/CustomOption";

const VehiculesListPage = () => {
  const [params] = useSearchParams()
  const [data, setData] = useState<Array<ModeleVehiculeEntre>>([])
  const [loading, setLoading] = useState(false)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchPage, setSearchPage] = useState<string>(params?.get('numeroVehicule') ?? '')
  const [isSearch, setIsSearch] = useState(false)
  const {currentUser} = useAuth()
  const [vehiculeToShow, setVehiculeToShow] = useState<ModeleVehiculeEntre>()
  const [marqueVehicule, setMarqueVehicule] = useState<any | undefined>([])
  const [modeleVehicule, setModeleVehicule] = useState<any | undefined>([])
  const [allMarqueVehicule, setAllMarqueVehicule] = useState<any | undefined>([])
  const [allModeleVehicule, setAllModeleVehicule] = useState<any | undefined>([])
  const [searchModel, setSearchModel] = useState<string>('')
  const [searchMarque, setSearchMarque] = useState<string>('')
  const [searchPhase, setSearchPhase] = useState<string>('')
  const [searchEnergie, setSearchEnergie] = useState<string>('')
  const [searchPuissance, setSearchPuissance] = useState<string>('')
  const [valueMarque, setValueMarque] = useState<any>([])
  const [valueModele, setValueModele] = useState<any>([])
  const [spinner, setSpinner] = useState(false)
  const [menuInputValue, setMenuInputValue] = useState<string>("")

  // Récupération les marques de vehicules
  const getMarqueVehiculeData = () => {
    getMarqueVehicule()
      .then((marqueRequest) => {
        if (marqueRequest?.status === 200) {
          if (marqueRequest?.data !== undefined) {
            const transformedData = marqueRequest.data.map((item) => ({
              marque: item.id,
              value: item.nom,
              label: item.nom,
            }))
            setAllMarqueVehicule([...transformedData])
            setMarqueVehicule([...transformedData])
            setLoading(false)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  // Récupération les modeles de vehicules
  const getModeleVehiculeData = () => {
    getModeleVehicule()
      .then((modeleRequest) => {
        if (modeleRequest?.status === 200) {
          if (modeleRequest?.data !== undefined) {
            const transformedData = modeleRequest.data.map((item) => ({
              marque: item.idMarque,
              value: item.nom,
              label: item.nom,
            }))
            setAllModeleVehicule([...transformedData])
            setModeleVehicule([...transformedData])
            setLoading(false)
          }
        }
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  // Chargement du contenu des listes de marque et modèle pour les filtres
  useEffect(() => {
    getMarqueVehiculeData()
    getModeleVehiculeData()
  }, [])

  // filtrer les données de modèle apres selection de marque
  useEffect(() => {
    if (valueMarque.length > 0 && allModeleVehicule.length > 0) {
      const filteredModele = allModeleVehicule.filter((vehicule) =>
        valueMarque.some((item) => vehicule?.marque === item.marque)
      )
      setModeleVehicule(filteredModele)
    }
  }, [valueMarque, allMarqueVehicule, allModeleVehicule])

  useEffect(() => {
    if (searchMarque !== "" || searchModel !== "" || searchPage !== "" ||searchPhase !== '' || searchEnergie !== '' || searchPuissance !== ''
    ) {
      getVehiculesData()
    } else {
      setData([])
      setVehiculeToShow(undefined)
    }
  }, [currentPage, searchPage, searchMarque, searchModel, searchPhase, searchEnergie, searchPuissance,])

  const getVehiculesData = () => {
    setSpinner(true)
    setVehiculeToShow(undefined)
    getVehicules(!isSearch ? currentPage : 1, searchPage, searchMarque, searchModel,false, searchPhase, searchEnergie, searchPuissance
  ).then(
      (vehiculesRequest) => {
        setNombreDePages(vehiculesRequest?.pages)
        setTotalPages(vehiculesRequest?.total)
        setCurrentPage(vehiculesRequest?.page)
        if (vehiculesRequest?.data !== undefined) {
          setData(vehiculesRequest?.data)
          if (vehiculesRequest?.data.length === 1 && params?.get('numeroVehicule')) {
            setVehiculeToShow(vehiculesRequest?.data[0])
          }
          setSpinner(false)
          setIsSearch(false)
        }
      }
    )
  }

  const formik = useFormik({
    initialValues: {allSearch: params?.get('numeroVehicule') ?? '', marque: '', modele: '', phase: '',
      energie: '',
      puissance: '',},
    onSubmit: (values, {setSubmitting}) => {
      setSearchPage(values.allSearch)
      setSearchMarque(values.marque)
      setSearchModel(values.modele)
      setSearchPhase(values.phase)
      setSearchEnergie(values.energie)
      setSearchPuissance(values.puissance)
    },
  })

  const handleMarqueChange = async (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      setValueMarque([]);
      setModeleVehicule(allModeleVehicule);
      formik.setFieldValue("marque", '');
    } else {
      // definir la valeur choisi de marque
      setValueMarque(data);

      // préparer la valeur à placer dans formik en cas de selection multiple
      const marques = data
        ? data.map(marque => marque.value)
          .filter((value, index, self) => self.indexOf(value) === index)
          .join(',')
        : '';
      formik.setFieldValue("marque", marques.toString());
    }
    setIsSearch(true);
    formik.submitForm();
  };

  const handleModeleChange = async (data) => {
    // Si il n'y a pas de valeur dans data
    if (data.length === 0) {
      setValueModele([]);
      formik.setFieldValue("modele", '');
    } else {
      // definir la valeur choisi de modele
      setValueModele(data);

      // préparer la valeur à placer dans formik en cas de selection multiple
      const modeles = data
        ? data.map(modele => modele.value)
          .filter((value, index, self) => self.indexOf(value) === index)
          .join(',')
        : '';
      formik.setFieldValue("modele", modeles);
    }
    setIsSearch(true);
    formik.submitForm();
  };

  // Style du select pour les filtres marque et modèle
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: '45px',
      minWidth: '200px',
      backgroundColor: 'transparent',
    }),
  }

  const filterOptions = (candidate: any, input: string) => {
    if (input) {
      const normalize = (text: string) =>
          text.replace(/\s*-\s*/g, ' - ').toLowerCase() // remplacer le "-"  en " - "

      return normalize(candidate.label).includes(normalize(input))
    }
    return true
  }

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className={vehiculeToShow ? 'col-lg-8 col-md-6' : 'col-lg-12 col-sm-12'}>
          <div className={`card card-xxl-stretch h-100`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-3 mb-1'>Véhicules</span>
              </h3>
            </div>
            {shouldDisplayFonctionnalite(currentUser, 'VOIR VEHICULE') && (
              <>
                {/* debut champs recherche */}
                <form className='card-header border-0 pt-5 pb-5' onSubmit={formik.handleSubmit}>
                  <div className='col-lg-3'>
                    <Select
                      styles={customStyles}
                      className='react-select-styled react-select-solid react-select-lg'
                      classNamePrefix='react-select'
                      options={marqueVehicule}
                      value={valueMarque}
                      placeholder='Marque'
                      isDisabled={(marqueVehicule.length === 0)}
                      isLoading={(marqueVehicule.length === 0)}
                      isClearable
                      isMulti
                      onChange={(data) => handleMarqueChange(data)}
                    />
                  </div>
                  <div className='col-lg-3'>
                    <Select
                      styles={customStyles}
                      className='react-select-styled react-select-solid react-select-lg'
                      classNamePrefix='react-select'
                      options={modeleVehicule}
                      value={valueModele}
                      placeholder='Modele'
                      isDisabled={(modeleVehicule.length === 0)}
                      isLoading={(modeleVehicule.length === 0)}
                      isClearable
                      isMulti
                      onChange={(data) => handleModeleChange(data)}
                      components={{Option: CustomOption}}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      blurInputOnSelect={false}
                      filterOption={filterOptions}
                      inputValue={menuInputValue}
                      onInputChange={(text, action) => {
                        if (action.action === 'input-change') {
                          setMenuInputValue(text)
                        } else if (action.action === 'menu-close' || action.action === 'input-blur') {
                          setMenuInputValue('')
                        }
                      }}
                    />
                  </div>
                  <div className=' col-lg-4'>
                    <div className='form-group d-flex'>
                      <div className='input-group'>
                        <input
                          type='text'
                          className='form-control h-100'
                          {...formik.getFieldProps('allSearch')}
                          name='allSearch'
                          placeholder='Recherche par numéro'
                        />
                        <button
                          type='submit'
                          className='btn btn-light border-0 input-group-append h-100'
                          onClick={() => setIsSearch(true)}
                        >
                          <i className='fas fa-search text-secondary fs-1'></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-3 mt-3'>
                    <input
                      type='text'
                      className='form-control h-100'
                      {...formik.getFieldProps('phase')}
                      name='phase'
                      placeholder='Phase'
                    />
                  </div>

                  <div className='col-lg-3 mt-3'>
                    <input
                      type='text'
                      className='form-control h-100'
                      {...formik.getFieldProps('energie')}
                      name='energie'
                      placeholder='Énergie'
                    />
                  </div>

                  <div className=' col-lg-4 mt-3'>
                    <div className='col-lg-9'>
                      <input
                        type='text'
                        className='form-control h-100'
                        {...formik.getFieldProps('puissance')}
                        name='puissance'
                        placeholder='Puissance'
                      />
                    </div>

                  </div>
                </form>
                {/* fin champs recherche */}
                {/* end::Header */}
                <>
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-150px'>Immatriculation</th>
                            <th className='min-w-140px'>Numéro</th>
                            <th className='min-w-140px'>Marque</th>
                            <th className='min-w-140px'>Modèle</th>
                            <th className='min-w-50px'>Phase</th>
                            <th className='min-w-140px'>Genre</th>
                            <th className='min-w-140px'>Energie</th>
                            <th className='min-w-140px'>Puissance</th>
                            <th className='min-w-40px text-end'>Actions</th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {spinner ? (
                            <tr>
                              <td colSpan={9} className='p-4 text-center h-500px'>
                                <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
                              </td>
                            </tr>
                          ) : data.length ? (
                            data.map((vehicule) => {
                              return (
                                <>
                                  <tr
                                    key={vehicule?.[0]?.id}
                                    style={{
                                      backgroundColor: vehicule == vehiculeToShow ? '#9AC331' : '',
                                    }}
                                  >
                                    <td>
                                      <div className='d-flex align-items-center'>
                                        <div className='d-flex justify-content-start flex-column'>
                                          <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0 ms-2'>
                                            {vehicule?.[0]?.immatriculation}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {vehicule?.[0]?.numero}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {vehicule?.[0]?.vehicule?.modele?.marque?.nom}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {vehicule?.[0]?.vehicule?.modele?.nom}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {vehicule?.[0]?.vehicule?.modele?.phase}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {vehicule?.[0]?.vehicule?.modele?.type?.code}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {vehicule?.[0]?.energie}
                                      </p>
                                    </td>
                                    <td>
                                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                                        {vehicule?.[0]?.vehicule?.modele?.puissance}
                                      </p>
                                    </td>
                                    <td>
                                      <div className='d-flex justify-content-end flex-shrink-0'>
                                        <span
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                          style={{cursor: 'pointer'}}
                                          data-tooltip-id='tooltip'
                                          data-tooltip-content='Détail du véhicule'
                                          data-tooltip-place='left'
                                        >
                                          <i
                                            className={`bi bi-eye fs-2 text-hover-primary ${(vehiculeToShow === vehicule?.[0]) ? 'text-primary' : ''}`}
                                            onClick={() => {
                                              if (vehiculeToShow !== vehicule?.[0]) {
                                                setVehiculeToShow(vehicule?.[0])
                                              } else {
                                                setVehiculeToShow(undefined)
                                              }
                                            }}
                                          ></i>
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={8} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    {(data.length !== 0) ? (
                      <Pagination
                        totalPages={totalPages}
                        nombreDePages={nombreDePages}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        locationState={0}
                      />
                    ) : ''}
                    {/* end::pagination*/}
                    {/*Affichage du tooltip*/}
                    <Tooltip id='tooltip' />
                  </div>
                </>
              </>
            )}
          </div>
        </div>
        <div className='col-lg-4 col-md-6'>
          {vehiculeToShow && <VehiculeToShowPage vehicule={vehiculeToShow} setVehiculeToShow={setVehiculeToShow} />}
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}

export {VehiculesListPage}
